import { quantityBus } from "@/event/product/quantityBus";
import { selectOptionsListHappy } from "@/happyTheme/event/product/selectOptionsListHappy";
import { showSelectedModalProductHappy } from "@/happyTheme/event/product/showSelectedModalProductHappy";
import { clearSelectOptionListHappy } from "./modal/clearSelectOptionListHappy";
import { relatedGroupBus } from "@/event/product/relatedGroupeBus";
import { productBus } from "@/event/product/productBus";

export function toggleSelectedModalProductHappy() {
    quantityBus.value = 1
    relatedGroupBus.value = []

    if (selectOptionsListHappy.value) {
        productBus.value = null
        clearSelectOptionListHappy()
    }

    showSelectedModalProductHappy.value = !showSelectedModalProductHappy.value
}